import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SearchBoxContainerModule } from '@dynamic-components/search-box-container/search-box-container.module';
import { PipesModule } from '@shared/ui/pipes/pipes.module';
import {
  JbBackgroundImageModule,
  JbBreadcrumbsModule,
  JbFlagModule,
  JbHeroModule,
  JbIconModule,
  JbImageModule,
} from 'jb-component-library';

import { LinksModule } from '../../shared/ui/links';
import {
  HeroContainerComponent,
  heroContainerResolver,
} from './hero-container.component';

const MODULES = [
  CommonModule,
  JbHeroModule,
  JbBreadcrumbsModule,
  JbIconModule,
  JbBackgroundImageModule,
  JbFlagModule,
  JbImageModule,
  LinksModule,
  PipesModule,
  SearchBoxContainerModule,
];

const DECLARATIONS = [HeroContainerComponent];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...MODULES, ...DECLARATIONS],
})
export class HeroContainerModule {
  static entry = HeroContainerComponent;
  static componentDataResolver = heroContainerResolver;
}
